export const CONTACT = {
  company: "ONE WORLD OF SPORTS",
  email: "sports@1worldcorp.com",
  phone: "+91 9930251077",
  phoneHref: "+919930251077",
};

export const BRIEFS = [
  {
    num: "01",
    title: "Run our tournament.",
    body: "Nineteen years of designing and running competitive events across sports, formats and levels.",
    img: "/illustrations/brief-01.png",
    color: "#3b6fb5",
  },
  {
    num: "02",
    title: "Build us a sporting property.",
    body: "From our own tournaments to year-round programmes created for brands and organisations.",
    img: "/illustrations/brief-02.png",
    color: "#f97316",
  },
  {
    num: "03",
    title: "Take it across the country.",
    body: "Single venue. Multiple cities. Parallel events. National programmes that connect people and places.",
    img: "/illustrations/brief-03.png",
    color: "#16a34a",
  },
  {
    num: "04",
    title: "Help us figure this out.",
    body: "Find the venue. Invent the format. Build the field. Untangle the logistics. Turn the idea into reality.",
    img: "/illustrations/brief-04.png",
    color: "#9333ea",
  },
  {
    num: "05",
    title: "Stay with us while it grows.",
    body: "We don't just execute. We partner, add value and grow the mandate as your ambitions do.",
    img: "/illustrations/brief-05.png",
    color: "#e62429",
  },
];

export const PROCESS = [
  { title: "Design", sub: "Formats & journeys", color: "#2563eb", img: "/illustrations/proc-design.png" },
  { title: "Operate", sub: "Sport & logistics", color: "#f97316", img: "/illustrations/proc-operate.png" },
  { title: "Activate", sub: "People & participation", color: "#16a34a", img: "/illustrations/proc-activate.png" },
  { title: "Scale", sub: "Cities & programmes", color: "#9333ea", img: "/illustrations/proc-scale.png" },
];

export const TIMELINE = [
  { year: "2016–17", name: "Red Bull Winning 5s", sport: "Soccer" },
  { year: "2018–19", name: "Red Bull Tashan", sport: "Kabaddi" },
  { year: "2019", name: "Red Bull Sponsorship", sport: "Pro Kabaddi League" },
  { year: "2020–22", name: "Red Bull Neymar Jr's Five", sport: "Soccer" },
  { year: "2023–24", name: "Red Bull Shuttle Up", sport: "Badminton" },
  { year: "2023–24", name: "Red Bull Beat the Pro", sport: "Badminton / Squash" },
  { year: "2023–24", name: "Red Bull Tlang Ruam", sport: "Urban Downhill Cycling" },
  { year: "2025–26", name: "Red Bull Campus Cricket", sport: "Cricket" },
  { year: "2025–26", name: "Red Bull Powerplay", sport: "Box Cricket" },
];

export const GATEWAYS = [
  {
    key: "work",
    title: "Work",
    body: "What we design, operate and activate across formats and platforms.",
    color: "#2563eb",
    image:
      "https://images.unsplash.com/photo-1774523195578-121a2d1da490?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBzcG9ydHMlMjB0b3VybmFtZW50JTIwYWN0aW9ufGVufDB8fHx8MTc4NzA3MTkxNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "clients",
    title: "Clients",
    body: "The organisations and brands who trust us with their biggest ideas.",
    color: "#f97316",
    image:
      "https://images.unsplash.com/photo-1774600551660-1065d43c1587?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBzcG9ydHMlMjB0b3VybmFtZW50JTIwYWN0aW9ufGVufDB8fHx8MTc4NzA3MTkxNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "people",
    title: "People",
    body: "The team, partners and collaborators behind every experience.",
    color: "#16a34a",
    image:
      "https://images.unsplash.com/photo-1657957746418-6a38df9e1ea7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzcG9ydHMlMjB0b3VybmFtZW50JTIwYWN0aW9ufGVufDB8fHx8MTc4NzA3MTkxNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "stories",
    title: "Stories",
    body: "Moments that moved people. Impact that lasted beyond the event.",
    color: "#9333ea",
    image:
      "https://images.pexels.com/photos/35898730/pexels-photo-35898730.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/3131406/pexels-photo-3131406.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  about:
    "https://images.pexels.com/photos/37718409/pexels-photo-37718409.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=800",
};
